/**
 * Read-only provider support API client (/api/provider/support/*).
 */

import { apiClient } from '../api/ApiClient.js';
import {
  ProviderSupportSubscriptionResponseSchema,
  ProviderSupportTenantResponseSchema,
  ProviderSupportTenantsResponseSchema,
  ProviderSupportTenantUsersResponseSchema,
  type ProviderSupportSubscriptionSummary,
  type ProviderSupportTenantSummary,
  type ProviderSupportTenantUser,
} from '@cnapse/shared/access.js';
import type * as dt from '@cnapse/shared/data.types.js';

class ProviderSupportService {
  async getTenants(): Promise<ProviderSupportTenantSummary[]> {
    const raw = await apiClient.request<unknown>('/provider/support/tenants');
    const parsed = ProviderSupportTenantsResponseSchema.parse(raw);
    return parsed.data.tenants;
  }

  async getTenant(tenantId: dt.Uuid): Promise<ProviderSupportTenantSummary> {
    const raw = await apiClient.request<unknown>(`/provider/support/tenants/${tenantId}`);
    const parsed = ProviderSupportTenantResponseSchema.parse(raw);
    return parsed.data.tenant;
  }

  async getTenantUsers(tenantId: dt.Uuid): Promise<ProviderSupportTenantUser[]> {
    const raw = await apiClient.request<unknown>(`/provider/support/tenants/${tenantId}/users`);
    const parsed = ProviderSupportTenantUsersResponseSchema.parse(raw);
    return parsed.data.users;
  }

  async getTenantSubscription(tenantId: dt.Uuid): Promise<ProviderSupportSubscriptionSummary> {
    const raw = await apiClient.request<unknown>(`/provider/support/tenants/${tenantId}/subscription`);
    const parsed = ProviderSupportSubscriptionResponseSchema.parse(raw);
    return parsed.data;
  }
}

export const providerSupportService = new ProviderSupportService();
